module.exports = __webpack_public_path__ + "img/0.6611f925.png";